import React from "react"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

const query = graphql`
  {
    site {
      siteMetadata {
        title
        description
      }
    }
  }
`

const Seo = ({ title, description, keywords }) => {
    const { site } = useStaticQuery(query)
    const metaDescription = description || site.siteMetadata.description
    return (
        <Helmet
            htmlAttributes={{ lang: "en" }}
            title={`${title}`}
            meta={
                [
                    { name: `description`, content: metaDescription },
                    { name: `keywords`, content: keywords }
                ]
            }
            style={[{
                'id': `Hero`
            }]}

        >
            {/*<link rel="icon" type="image/x-icon" href="/public/static/favicon.ico" sizes="16x16" />*/}
            <style id={'Hero'}></style>
        </Helmet>
    )
}

export default Seo
